exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/new-game-menu/new-game-menu.component.css
// module id = ./src/app/new-game-menu/new-game-menu.component.css
// module chunks = 1